/**
 *创建新运单
 */
<template>
  <div class="contents">
    <div class="content_box">
      <div class="line"></div>
      <div class="title_text">创建新运单</div>
    </div>
    <div class="center_box">
      <div class="step_box_box">
        <div class="step_box" v-if="step == 1">
          <div class="step_box_top">
            <div class="step_number">01</div>
            <div class="step_box_text_l">(必填)</div>
          </div>
          <div class="line_box"></div>
          <div class="step_box_text_b">选择线路</div>
        </div>
        <div class="step_box" v-if="step != 1">
          <div class="step_box_top">
            <div class="step_number text_color text_color1">01</div>
            <div class="step_box_text_l text_color">(必填)</div>
          </div>
          <div class="line_box bgc"></div>
          <div class="step_box_text_b text_color text_size">选择线路</div>
        </div>
        <div class="step_box" v-if="step != 2">
          <div class="step_box_top">
            <div class="step_number text_color text_color1">02</div>
            <div class="step_box_text_l text_color">(必填)</div>
          </div>
          <div class="line_box bgc"></div>
          <div class="step_box_text_b text_color text_size">
            填写运单和收件人信息
          </div>
        </div>
        <div class="step_box" v-if="step == 2">
          <div class="step_box_top">
            <div class="step_number">02</div>
            <div class="step_box_text_l">(必填)</div>
          </div>
          <div class="line_box"></div>
          <div class="step_box_text_b">填写运单和收件人信息</div>
        </div>
        <div class="step_box" v-if="step != 3">
          <div class="step_box_top">
            <div class="step_number text_color text_color1">03</div>
            <div class="step_box_text_l text_color">(必填)</div>
          </div>
          <div class="line_box bgc"></div>
          <div class="step_box_text_b text_color text_size">
            填写包裹物品信息
          </div>
        </div>
        <div class="step_box" v-if="step == 3">
          <div class="step_box_top">
            <div class="step_number">03</div>
            <div class="step_box_text_l">(必填)</div>
          </div>
          <div class="line_box"></div>
          <div class="step_box_text_b">填写包裹物品信息</div>
        </div>
        <div class="step_box" v-if="step != 4">
          <div class="step_box_top">
            <div class="step_number text_color text_color1">04</div>
            <div class="step_box_text_l text_color">(选填)</div>
          </div>
          <div class="line_box bgc"></div>
          <div class="step_box_text_b text_color text_size">填写备注和图片</div>
        </div>
        <div class="step_box" v-if="step == 4">
          <div class="step_box_top">
            <div class="step_number">04</div>
            <div class="step_box_text_l">(选填)</div>
          </div>
          <div class="line_box"></div>
          <div class="step_box_text_b">填写备注和图片</div>
        </div>
      </div>

      <!-- 步骤1  -->
      <div v-if="step == 1">
        <div class="step_boxs_details_titile">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">选择线路</div>
        </div>
        <!-- 仓库列表 -->
        <div class="city_box">
          <div
            :class="index == click ? 'city_list_box' : 'city_list_boxs'"
            v-for="(item, index) in warehouseList"
            :key="index"
            @click="selectroute(item.id, index)"
          >
            <div :class="click == index ? 'triangle' : ''"></div>
            <div>{{ item.name }}</div>
          </div>
          <!-- <div class="city_list_boxs">{{}}</div> -->
        </div>
        <div class="transportation_type_box" v-loading="routeLoading">
          <el-row :gutter="10">
            <!-- <el-empty v-if='circuitData.content.length == 0' description="暂无数据"></el-empty> -->
            <el-col
              :xs="24"
              :sm="12"
              :md="12"
              :lg="5"
              :xl="5"
              v-for="(item, index) in circuitData.content"
              :key="index"
              v-if="item.isshow"
            >
              <div class="grid-content bg-purple">
                <div
                  class="transportation_type_list"
                  @click="last_steps(item, '2')"
                >
                  <div class="transportation_box_list">
                    <div class="transportation_img_box">
                      <!-- <img src="../../assets/img/swiper.png" alt="" /> -->
                      <img v-if="item.photo" :src="item.photo" alt="" />
                      <img v-else src="@/assets/img/route.png" alt="" />
                      <div class="transportation_center_box"></div>
                      <div class="transportation_text_op">
                        <div class="transportation_text">{{ item.name }}</div>
                      </div>
                    </div>
                    <div>
                      <div class="transportation_text_titile">
                        {{ item.name }}
                      </div>
                      <div class="transportation_text_details">
                        {{ item.description }}
                      </div>

                      <img
                        class="arrows_box"
                        src="@/assets/img/img2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div></div
            ></el-col>
          </el-row>
          <div class="paging_box">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="circuitData.totalElements"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 步骤二 -->
      <div v-if="step == 2">
        <div class="step_boxs_details_titile">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">填写运单号</div>
        </div>
        <div class="fill_in_list_box">
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">运单号</div>
              <div class="fill_in_title_l">*</div>
            </div>
            <input
              type="text"
              disabled
              v-model="order.ordernumber"
              placeholder="请输入运单号"
              class="input_box"
            />
          </div>
          <div class="fill_in_list" v-if="isfromchina == 1">
            <div class="fill_in_list_l">
              <div class="fill_in_title">国内快递单号</div>
              <div class="fill_in_title_l">*</div>
            </div>
            <input
              @input="inputBtn"
              v-if="isfromchina == 1"
              v-model="order.domesticnumber"
              type="text"
              placeholder="请输入国内快递单号"
              class="input_box"
            />
          </div>
          <div class="fill_in_list" v-if="isfromchina == 1">
            <div class="fill_in_list_l">
              <div class="fill_in_title">国内快递公司</div>
              <div class="fill_in_title_l">*</div>
            </div>
            <!-- <input
              disabled
              v-if="isfromchina == 1"
              v-model="order.domesticcarrier"
              type="text"
              placeholder="根据快递单号获取快递公司"
              class="input_box"
            /> -->
            <el-select
              v-if="isfromchina == 1"
              class="input_select"
              v-model="order.domesticcarrier"
              placeholder="请选择国内快递公司"
            >
              <el-option
                v-for="item in expressData"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="step_boxs_details_titile">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">填写收件人信息</div>
          <el-button
            v-if="order.isfromchina == 0"
            type="primary"
            @click="addAddressBtn"
            icon="el-icon-plus"
            style="margin-left: 20px"
            plain
            >选择</el-button
          >
        </div>
        <div class="fill_in_list_box">
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">收件人姓名</div>
            </div>

            <input
              v-model="selectAddress.consignee"
              type="text"
              placeholder="请输入收件人姓名"
              class="input_box"
            />
          </div>
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">收件人电话</div>
            </div>

            <input
              v-model="selectAddress.mobile"
              type="text"
              placeholder="请输入收件人电话"
              class="input_box"
            />
          </div>
        </div>
        <div class="fill_in_list_box margin_top">
          <!-- <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">收件人微信号</div>
            </div>
            <input
              type="text"
              placeholder="请输入收件人微信号"
              class="input_box"
            />
          </div> -->
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">收件人地址</div>
            </div>
            <div class="input_box">
              {{ selectAddress.province }}{{ selectAddress.city
              }}{{ selectAddress.district }}{{ selectAddress.detailArea }}
            </div>
            <!-- <input
            :value="address.province+address.city+address.district+address.detailArea"
              type="text"
              placeholder="请输入收件人地址"
              class="input_box"
            /> -->
          </div>
        </div>
        <div class="step_box_l">
          <div class="last_step" data-id="1" @click="last_step($event, '1')">
            上一步
          </div>
          <div class="last_step_l" @click="last_step($event, '3')">下一步</div>
        </div>
      </div>
      <!-- 步骤三 -->
      <div class="step_three" v-if="step == 3">
        <div class="step_boxs_details_titile">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">填写包裹物品信息</div>
        </div>
        <div class="operating_button_box">
          <div class="operating_button_l">
            <div class="operating_button_l_l" @click="addBox">+添加箱号</div>
            <div class="operating_button_l_l color_2" @click="delBox">
              -删除箱号
            </div>
          </div>
        </div>
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            v-for="(items, indexs) in box"
            :label="indexs"
            :value="indexs"
            :key="indexs"
          >
            <div class="table_box">
              <div class="table_item">
                <div class="table_item_title_l">
                  <div class="input_frg">
                    <div class="case_number">箱号{{ indexs + 1 }}</div>
                    <div
                      style="width: 70%; display: flex"
                      class=""
                      v-if="isfromchina == 0"
                    >
                      <el-select
                        @change="selectGoods"
                        v-model="value"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入物品中文名称"
                        :remote-method="remoteMethod"
                        :loading="loading"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.name"
                          :value="JSON.stringify(item)"
                        >
                        </el-option>
                      </el-select>
                      <!-- <input
                    placeholder="请输入物品中文名称"
                    class="inout_uio"
                    style="background: #f1f3f6"
                    type="text"
                  /> -->

                      <el-button
                        class="button_L"
                        @click="searchGoods(indexs)"
                        type="primary"
                        >搜索</el-button
                      >
                    </div>
                  </div>
                  <div class="operating_button_l_l" @click="addPackage(indexs)">
                    +添加内件
                  </div>
                </div>
                <div
                  class="table_item_box"
                  v-for="(item, index) in items.itemVoList"
                  :key="index"
                >
                  <div class="table_item_box_l">
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">内件名称</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.name"
                        type="text"
                        placeholder="请输入物品中文名称"
                        class="table_item_input"
                      />
                    </div>
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">申报价值</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.claimprice"
                        type="number"
                        min="0"
                        placeholder="请输入申报价值"
                        class="table_item_input"
                      /><span style="margin-left: 5px"> RMB</span>
                    </div>
                  </div>
                  <div class="table_item_box_l">
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">品牌</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.brand"
                        type="text"
                        placeholder="请输入品牌"
                        class="table_item_input"
                      />
                    </div>
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">数量</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        min="1"
                        v-model="item.count"
                        type="number"
                        placeholder="请输入数量"
                        class="table_item_input"
                      />
                    </div>
                  </div>
                  <div class="table_item_box_l">
                    <div class="table_item_box_l_r" v-if="isfromchina == 1">
                      <div class="fill_in_title">材质</div>
                      <div class="fill_in_title_l">*</div>
                      <el-select
                        v-model="item.material"
                        class="input_select_table"
                        placeholder="请选择材质"
                      >
                        <el-option
                          v-for="item in cities"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="table_item_box_l_r" v-if="isfromchina == 0">
                      <div class="fill_in_title">规格</div>
                      <div class="fill_in_title_l">*</div>
                      <input
                        v-model="item.format"
                        type="text"
                        placeholder="请输入规格"
                        class="table_item_input"
                      />
                    </div>
                    <div class="table_item_box_l_r">
                      <div class="fill_in_title">种类</div>
                      <div class="fill_in_title_l">*</div>
                      <el-select
                        value-key="name"
                        class="input_select_table"
                        v-model="item.category"
                        placeholder="请选择种类"
                      >
                        <el-option
                          v-for="item in kindData"
                          :key="item.Item"
                          :label="item.Item"
                          :value="item.Item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div>
                    <div>
                      <!-- :on-success="handleAvatarSuccess"uploadHttpRequest(file,indexs,index)
                        :before-upload="beforeAvatarUpload" (file)=>{return onUploadSuccessImggrey(file ,scope.row)}-->
                      <el-upload
                        action="#"
                        :limit="limit"
                        class="avatar-uploader"
                        accept=".png,.jpg"
                        :http-request="
                          (file) => {
                            return uploadHttpRequest(file, indexs, index);
                          }
                        "
                        :show-file-list="false"
                        :on-change="handleAvatarSuccess(indexs, index)"
                        :before-upload="beforeAvatarUpload(indexs, index)"
                      >
                        <!-- :on-success="" -->
                        <img
                          v-if="item.photoUrl"
                          :src="item.photoUrl"
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </div>
                  </div>
                  <div>
                    <div
                      class="operating_button_l_l color_2"
                      @click="delPackage(indexs, index)"
                    >
                      -删除
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-checkbox>
        </el-checkbox-group>

        <div class="step_box_s">
          <div class="last_step" @click="last_step($event, '2')">上一步</div>
          <div class="last_step_l margin_right" @click="last_step($event, '4')">
            下一步
          </div>
        </div>
      </div>
      <!-- 步骤四 -->
      <div v-if="step == 4">
        <div class="step_boxs_details_titile">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">填写运单备注</div>
        </div>
        <div class="fill_in_list_box" style="margin-bottom: 30px">
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">保险金额(CA$)</div>
            </div>
            <div class="displayC">
              <input
                @input="insuranceInput"
                v-model="order.insurance"
                type="number"
                min="0"
                placeholder="请输入保险金额 (选填)"
                class="input_box"
              />

              <span style="color: #999; font-size: 15px">CA$</span>
            </div>
          </div>
        </div>
        <div
          class="fill_in_list_box"
          style="margin-bottom: 30px"
          v-if="order.insurance > 0"
        >
          <div class="fill_in_list" style="border: none">
            <div class="fill_in_list_l">
              <div class="fill_in_title">保费</div>
            </div>
            <div class="displayC">
              <input
                disabled
                v-model="insuranceFee"
                type="text"
                class="input_box"
              />
              <span style="color: #999; font-size: 15px">CA$</span>
            </div>
          </div>
        </div>
        <div class="fill_in_list_box">
          <div class="fill_in_list">
            <div class="fill_in_list_l">
              <div class="fill_in_title">备注</div>
            </div>
            <input
              v-model="order.memo"
              type="text"
              placeholder="请输入备注 (选填)"
              class="input_box"
            />
          </div>
        </div>
        <div class="step_boxs_details_titile">
          <div class="circle_l"></div>
          <div class="circle_r"></div>
          <div class="text_xl">上传照片</div>
        </div>
        <div style="display: flex">
          <el-upload
            class="upload_img"
            accept=".png,.jpg"
            action="*"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadHttpRequests"
          >
            <img
              v-if="order.photourl != ''"
              :src="order.photourl"
              class="avatar"
            />
            <el-button size="small" type="primary" v-if="order.photourl == ''"
              >点击上传图片</el-button
            >
          </el-upload>
          <el-upload
            :limit="limit"
            class="upload_img"
            accept=".xlsx,.xls,.doc,.docx,.pdf,.txt"
            action="*"
            :show-file-list="true"
            :http-request="uploadHttpRequestss"
          >
            <el-button size="small" type="primary">点击上传文件</el-button>
            <!-- <div style="font-size:22px;color:#eee">{{enclosureName}}</div> -->
          </el-upload>
        </div>

        <div style="margin-top: 30px" class="">
          上传包裹外包装照片/文件（选填）
        </div>

        <el-dialog :visible.sync="dialogVisible" size="tiny">
          <img width="100%" src="" alt="" />
        </el-dialog>
        <div class="step_box_l">
          <div class="last_step" @click="last_step($event, '3')">上一步</div>
          <el-button
            type="primary"
            round
            class="last_step_l"
            :loading="loading"
            @click="submit"
            >保存订单</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      center
      title="选择地址"
      :visible.sync="dialogVisibleAddress"
      width="40%"
      :before-close="handleClose"
    >
      <div class="flex_box">
        <el-button type="primary" @click="addAddress" plain
          >+新增收货人信息</el-button
        >
      </div>
      <div class="address_model">
        <el-radio
          width="100%"
          size="medium"
          v-model="selectAddresss"
          :label="item"
          v-for="(item, index) in addressList.content"
          :key="index"
        >
          <div class="address_item">
            <div class="user_info_title">
              <div class="user_info">
                <div class="user_name">{{ item.consignee }}</div>
                <el-button
                  v-if="item.isDefault == 1"
                  type="primary"
                  size="mini"
                  round
                  >默认地址</el-button
                >
              </div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">中国收货人：</div>
              <div class="title_details">{{ item.consignee }}</div>
            </div>
            <div class="user_info">
              <div class="title_text_gh">中国电话：</div>
              <div class="title_details">{{ item.mobile }}</div>
            </div>
            <div class="user_info_title">
              <div class="user_info" style="margin: 0">
                <div class="title_text_gh">中国地址：</div>
                <div class="title_details">
                  {{ item.province }}{{ item.city }}{{ item.district
                  }}{{ item.detailArea }}
                </div>
              </div>
            </div>
          </div>
        </el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAddress = false">取 消</el-button>
        <el-button type="primary" @click="affirmAddress">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="AddressdialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <span>未获取到您的默认收货地址，请前往个人中心添加默认地址</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="toUser">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="UserinfoDialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <span>您的个人信息并不完整，请填写您的真实姓名，邮箱，所属销售代表和取货点。</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="toUserinfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudDept from "@/api/userMG";
import Pagination from "../../components/Pagination";
// import img from '@/assets/img/route.png';
import Cookies from "js-cookie";
import Config from "@/settings";
import AWS from "aws-sdk";
export default {
  data() {
    return {
      routeLoading: false,
      insuranceFee: 0,
      limit: 1,
      AddressdialogVisible: false,
      UserinfoDialogVisible: false,
      dialogVisible: false,
      // imgrote:img,
      loading: false,
      isDefault: 1,
      radio: "",
      selectAddresss: "",
      selectAddress: {
        consignee: "",
        mobile: "",
      },
      addressList: [],
      dialogVisibleAddress: false,
      isfromchina: "",
      memo: "",
      checkedCities: [],
      address: "",
      goodsData: null,
      options: [],
      value: [],
      list: [],
      loading: false,
      box: [
        {
          itemVoList: [
            {
              brand: "",
              category: "",

              claimprice: "",
              count: "",
              englishname: "",
              format: "",
              name: "",
              photoUrl: "",
              material: "",
            },
          ],
        },
      ],

      cities: [
        "金属",
        "木质",
        "棉麻",
        "塑料",
        "玻璃",
        "针织",
        "皮革",
        "纤维",
        "液体",
        "纸质",
        "石质",
        "硅胶",
        "食品",
        "药品",
        "化学材料",
      ],
      order: {
        isfromchina: "", //是否从中国到加拿大
        memo: "", //备注
        domesticnumber: "", //国内快递单号
        domesticcarrier: "", //国内快递公司
        routeid: "", //线路
        ordernumber: "", //运单号
        recipientaddressid: "", //地址id
        photourl: "",
        warehouseid: "", //仓库id
        route: "",
        enclosure: "",
        insurance: "",
      },
      insurance: "",
      click: 0,
      warehouseList: [],
      step: 1,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入部门代码", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      page: 1,
      size: 20,
      circuitData: [],
      expressData: [],
      expressDataProp: {
        value: "id",
        label: "name",
      },
      kindData: [],
      boxData: [],
      itemVoListIndex: "",
      boxIndex: "",
      code: "",
      isselectOrderAllAccuracy: null,
      enclosureName: "",
      userInfo:null,
    };
  },
  // 注册组件
  components: {
    Pagination,
    // titile,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.user();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    user() {
      let data = {
        // id: logistics_user.id,
      };
      crudDept.getUser().then((res) => {
        this.userInfo = res;
        this.warehouse();
        this.express();
      });
    },
    //填写保险金额
    insuranceInput(e) {
      //concole.log(this.order.insurance);
      this.order.insurance = Number(this.order.insurance);
      this.insuranceFee = (this.order.insurance * 1) / 10;
    },
    //检验快递单号是否重复
    selectOrderAllAccuracy() {
      var data = {
        domesticnumber: this.order.domesticnumber,
        size: 1,
        page: 1,
      };
      crudDept.selectOrderAllAccuracy(data).then((res) => {
        if (res.content != "") {
          if (res.content.length > 0) {
            this.$message.error("快递单号重复，请重新输入");
            return false;
          }
        }
      });
    },
    uploadHttpRequestss(param) {
      var that = this;
      var credentials = {
        accessKeyId: "AKIAJEPDGNAK3LSG4D7Q",
        secretAccessKey: "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",
      };
      AWS.config.update(credentials);
      AWS.config.region = "us-east-1"; //设置区域
      var bucket = new AWS.S3({ params: { Bucket: "eplus-ex" } }); //选择桶
      var ksy = Number(new Date()) + Math.random().toString(36).substr(2);
      var params = {
        methods: "put",
        Body: param.file,
        Key: "order/" + ksy + "/" + param.file.name,
        ContentType: param.file.type,
        "Access-Control-Allow-Credentials": "*",
        ACL: "public-read",
      };
      ////concole.log(params);
      bucket.upload(params, function (err, data) {
        if (data) {
          that.order.enclosure = data.Location;
          that.enclosureName = data.Key;
        }
      });
    },
    uploadHttpRequests(param) {
      var that = this;
      var credentials = {
        accessKeyId: "AKIAJEPDGNAK3LSG4D7Q",
        secretAccessKey: "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",
      };
      AWS.config.update(credentials);
      AWS.config.region = "us-east-1"; //设置区域
      var bucket = new AWS.S3({ params: { Bucket: "eplus-ex" } }); //选择桶
      var ksy = Number(new Date()) + Math.random().toString(36).substr(2);
      var params = {
        methods: "put",
        Body: param.file,
        Key: "order/" + ksy + "/" + param.file.name,
        ContentType: param.file.type,
        "Access-Control-Allow-Credentials": "*",
        ACL: "public-read",
      };
      ////concole.log(params);
      bucket.upload(params, function (err, data) {
        if (data) {
          that.order.photourl = data.Location;
        }
      });
    },
    inputBtn(e) {
      this.order.domesticnumber = this.order.domesticnumber.replace(/\s/g, "");
      /*
      var data = {
        orderNumber: this.order.domesticnumber.replace(/\s/g, ""),
      };
      crudDept.queryExpressCompanyNumber(data).then((res) => {
        if (res.comCode != null) {
          this.order.domesticcarrier = res.comCode;
        }
      });
      */
    },
    //上传图片
    uploadHttpRequest(param, indexs, index) {
      this.itemVoListIndex = index;
      this.boxIndex = indexs;
      ////concole.log()
      var that = this;
      var credentials = {
        accessKeyId: "AKIAJEPDGNAK3LSG4D7Q",
        secretAccessKey: "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",
      };
      AWS.config.update(credentials);
      AWS.config.region = "us-east-1"; //设置区域
      var bucket = new AWS.S3({ params: { Bucket: "eplus-ex" } }); //选择桶
      var ksy = Number(new Date()) + Math.random().toString(36).substr(2);
      var params = {
        methods: "put",
        Body: param.file,
        Key: "order/" + ksy + "/" + param.file.name,
        ContentType: param.file.type,
        "Access-Control-Allow-Credentials": "*",
        ACL: "public-read",
      };
      ////concole.log(params);
      bucket.upload(params, function (err, data) {
        if (data) {
          that.box[that.boxIndex].itemVoList[that.itemVoListIndex].photoUrl =
            data.Location;
        }
      });
    },
    //去设置默认地址
    toUser() {
      this.$router.push({ path: "../userInfo/address" });
      this.AddressdialogVisible = false;
      this.UserinfoDialogVisible = false;
    },
    toUserinfo() {
      this.$router.push({ path: "../userInfo/userInfo" });
      this.AddressdialogVisible = false;
      this.UserinfoDialogVisible = false;
    },
    selectcategory(e) {
      ////concole.log(e);
    },
    //提交订单
    submit() {
      var that = this;
      // var code = this.code;
      //   var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      //   var orderstartnumber = logistics_user.orderstartnumber;
      //   var d = new Date("2018-01-01 00:00:00") / 1000;
      //   var dd = Math.round(Date.parse(new Date()) / 1000 - d);
      //   this.order.ordernumber = code + orderstartnumber + dd.toString();
      this.order.orderbaggageVoList = this.box;

      that.loading = true;

      crudDept
        .createOrder(this.order)
        .then((res) => {
          ////concole.log(res);
          setTimeout(() => {
            that.$message({
              message: "操作成功",
              type: "success",
            });
            that.loading = false;
            this.step = 1;
          }, 1500);

          this.order = {
            isfromchina: "", //是否从中国到加拿大
            memo: "", //备注
            domesticnumber: "", //国内快递单号
            domesticcarrier: "", //国内快递公司
            routeid: "", //线路
            ordernumber: "", //运单号
            recipientaddressid: this.selectAddress.id, //地址id
          };
          this.box = [
            {
              itemVoList: [
                {
                  brand: "",
                  category: "",

                  claimprice: "",
                  count: "",
                  englishname: "",
                  format: "",
                  name: "",
                  material: "",
                  photourl: "",
                },
              ],
            },
          ];
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //d点击选择地址
    addAddressBtn() {
      this.dialogVisibleAddress = true;
      this.isDefault = "";
      this.addressData();
    },
    //点击新增地址
    addAddress() {
      this.$router.push({
        path: "/userInfo/addAddress?type=" + this.isfromchina + "&status=0",
      });
      // this.$router.push({ path: "/userInfo/addAddress" });
    },
    //确认选择的地址
    affirmAddress() {
      ////concole.log(this.selectAddress);
      this.selectAddress = this.selectAddresss;
      this.order.recipientaddressid = this.selectAddresss.id;
      this.dialogVisibleAddress = false;
    },
    //关闭地址弹框
    handleClose() {
      this.dialogVisibleAddress = false;
    },
    //收货地址
    addressData() {
      var data = {
        page: 1,
        size: 50,
        isDefault: this.isDefault,
        addresstype: this.isfromchina,
      };
      crudDept.address(data).then((res) => {
        if (this.isDefault == 1) {
          if (res.content.length > 0) {
            this.selectAddress = res.content[0];
            this.order.recipientaddressid = res.content[0].id;
          } else {
            this.AddressdialogVisible = true;
          }
        }
        ////concole.log(res);
        this.addressList = res;
      });
    },
    userinfoData() {
      if (typeof Cookies.get("logistics_user") == "string") {
        var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      } else {
        var logistics_user = Cookies.get("logistics_user");
      }
      var data = {
        id: logistics_user.id,
      };
      crudDept.getUser(data).then((userInfo) => {
        Cookies.set("logistics_user", userInfo, {
          expires: Config.passCookieExpires,
        });
        if (!userInfo.mailbox || userInfo.mailbox.trim() === '' ||
            !userInfo.realName || userInfo.realName.trim() === '' || 
            !userInfo.pickUpLocationId || !userInfo.belongstoid) {
              console.log('visible', userInfo)
          this.UserinfoDialogVisible = true;
        }
      });
    },
    handleCheckedCitiesChange(e) {
      var data = this.box;
      var datas = [];
      for (var j = 0; j < e.length; j++) {
        datas.push(data[e[j]]);
      }
      this.boxData = datas;
    },
    //点击删除箱号
    delBox() {
      var data = this.box;
      ////concole.log(data);
      var checkedCities = this.boxData;
      ////concole.log(checkedCities);
      var leg = data.length;
      for (var i = 0; i < leg; i++) {
        for (var j = 0; j < checkedCities.length; j++) {
          if (data[i]) {
            if (data[i] == checkedCities[j]) {
              data.splice(i, 1);
            }
          }
        }
      }
      this.boxData = [];
      this.checkedCities = [];
    },
    //点击添加箱号
    addBox() {
      var data = {
        itemVoList: [
          {
            brand: "",
            category: "",
            claimprice: "",
            count: "",
            englishname: "",
            format: "",
            name: "",
            material: "",
            photoUrl: "",
          },
        ],
      };
      this.box = this.box.concat(data);
    },

    //选中物品
    selectGoods(e) {
      //concole.log(JSON.parse(e));
      e = JSON.parse(e);

      var data = {
        brand: e.brand,
        category: e.details,
        claimprice: "",
        count: "",
        englishname: "",
        format: e.format,
        name: e.name,
        photoUrl: "",
        material: "",
        photourl: "",
      };
      this.goodsData = data;
    },
    //点击搜索物品
    searchGoods(indexs) {
      var data = this.box[indexs].itemVoList.concat(this.goodsData);
      this.box[indexs].itemVoList = data;
    },
    //搜索物品
    remoteMethod(e) {
      ////concole.log(e);
      var data = {
        name: e,
        page: 1,
        size: 50,
      };
      crudDept.goods(data).then((res) => {
        ////concole.log(res);
        this.options = res.content;
      });
    },
    //删除内件
    delPackage(indexs, index) {
      ////concole.log(indexs, index);
      var data = this.box[indexs].itemVoList;
      data.splice(index, 1);
    },
    //添加内件
    addPackage(index) {
      var datas = {
        brand: "",
        category: "",
        claimprice: "",
        count: "",
        englishname: "",
        format: "",
        name: "",
        material: "",
        photoUrl: "",
      };
      var data = this.box[index].itemVoList.concat(datas);
      this.box[index].itemVoList = data;
    },
    handleAvatarSuccess(indexs, index) {
      // this.itemVoListIndex=index;
      // this.boxIndex=indexs;
    },
    beforeAvatarUpload(indexs, index) {
      // //concole.log(indexs,index)
    },
    //上传tupian
    handlePictureCardPreview() {},
    //删除图片
    handleRemove() {},
    //商品种类
    kind() {
      var data = {
        size: 100,
        page: 1,
      };
      crudDept.kind(data).then((res) => {
        ////concole.log(res);
        this.kindData = res.content;
      });
    },
    //快递公司
    express() {
      var data = {};
      crudDept.express(data).then((res) => {
        ////concole.log(res);
        this.expressData = res;
      });
    },
    //点击仓库
    selectroute(id, index) {
      ////concole.log(id, index);
      this.circuitData = "";
      this.click = index;
      this.order.warehouseid = id;
      this.bannedUserRoute(id);
      this.reset(id);
    },
    //线路限制
    bannedUserRoute(id) {
      var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      var data = {
        userid: logistics_user.id,
      };
      crudDept.bannedUserRoute(data).then((res) => {
        //concole.log(res.content.length > 0, "不下时");
        this.circuit(id, res.content);
      });
    },
    //数据重置
    reset() {
      this.page = 1;
      this.size = 20;
    },
    //线路
    circuit(id, userRoute) {
      this.routeLoading = true;
      var data = {
        warehouseid: id,
        page: this.page,
        size: this.size,
      };
      crudDept
        .circuit(data)
        .then((res) => {
          //concole.log(res.content, "items");
          this.routeLoading = false;
          if (userRoute.length > 0 && res.content.length > 0) {
            for (var j = 0; j < res.content.length; j++) {
              //concole.log(res.content[j], "item");
              const matched = userRoute.find(
                ({ routeid }) => routeid === res.content[j].id
              );

              //concole.log(matched, "dd");

              if (matched) {
                // //concole.log()
                res.content[j].isshow = false;
                // res.content.splice(j, 1);
              } else {
                res.content[j].isshow = true;
              }
            }
            this.circuitData = res;
          } else {
            if (res.content.length > 0) {
              for (var j = 0; j < res.content.length; j++) {
                res.content[j].isshow = true;
              }
            }

            this.circuitData = res;
          }
        })
        .catch((res) => {
          this.routeLoading = false;
        });
    },

    //仓库
    warehouse() {
      var data = {};
      crudDept.warehouse(data).then((res) => {
        this.warehouseList = res.content;
        ////concole.log(res.content[0].id);
        this.bannedUserRoute(res.content[0].id);
        // this.circuit(res.content[0].id);
        this.order.warehouseid = res.content[0].id;
      });
    },
    last_steps(e, num) {
      this.order.routeid = e.id;
      this.order.route = e.name;
      this.kindData = JSON.parse(e.price);

      this.code = e.code;
      if (num == 2) {
        var code = e.code;
        if(!this.userInfo){
         this.$message.error("未获取到用户信息，请重新登录");
         window.location.href='https://epluscanada.com/login?login=1&jumpLogin=1'
         return false
        }
        var orderstartnumber = this.userInfo.orderstartnumber;
        var time = "2018-01-01 00:00:00";
        time = time.replace(/\-/g, "/");
        var d = new Date(time) / 1000;
        var dd = Math.round(Date.parse(new Date()) / 1000 - d);
        this.order.ordernumber = code + orderstartnumber + dd.toString();
        this.isfromchina = e.type == 4 ? 0 : 1;
        this.order.isfromchina = e.type == 4 ? 0 : 1;
        this.addressData();
        this.userinfoData();
      }
      this.step = num;
    },

    last_step(e, num) {
      if (this.order.isfromchina == 1) {
        if (
          this.order.domesticnumber == "" ||
          this.order.domesticcarrier == "" ||
          this.order.recipientaddressid == ""
        ) {
          ////concole.log(this.order);
          this.$message.error("请完善运单信息");
          return false;
        } else if (this.order.domesticnumber.indexOf(" ") != -1) {
          this.order.domesticnumber = this.order.domesticnumber.replace(
            /\s/g,
            ""
          );
          // this.$message.error("请输入正确的快递单号");
          // return false;
        }

        // this.selectOrderAllAccuracy();
      } else if (this.order.isfromchina == 0) {
        if (this.order.recipientaddressid == "") {
          this.$message.error("请选择到货地址");
          return false;
        }
      }
      if (num == 4) {
        for (var i = 0; i < this.box.length; i++) {
          if (this.box[i].itemVoList == "") {
            this.$message({
              showClose: true,
              message: "箱号不能为空",
              type: "warning",
            });
            return false;
          }
          for (var j = 0; j < this.box[i].itemVoList.length; j++) {
            ////concole.log(this.box[i].itemVoList[j]);

            if (this.box[i].itemVoList[j].name == "") {
              this.$message({
                showClose: true,
                message: "请输入内件名称",
                type: "warning",
              });
              return false;
            }
            if (this.box[i].itemVoList[j].brand == "") {
              this.$message({
                showClose: true,
                message: "请输入品牌名称",
                type: "warning",
              });
              return false;
            }

            if (this.isfromchina == 1) {
              if (this.box[i].itemVoList[j].material == "") {
                this.$message({
                  showClose: true,
                  message: "请选择材质",
                  type: "warning",
                });
                return false;
              }
            } else {
              if (this.box[i].itemVoList[j].format == "") {
                this.$message({
                  showClose: true,
                  message: "请输入规格",
                  type: "warning",
                });
                return false;
              }
            }

            if (this.box[i].itemVoList[j].claimprice == "") {
              this.$message({
                showClose: true,
                message: "请输入申报价值",
                type: "warning",
              });
              return false;
            }
            if (this.box[i].itemVoList[j].count == "") {
              this.$message({
                showClose: true,
                message: "请输入数量",
                type: "warning",
              });
              return false;
            }
            if (this.box[i].itemVoList[j].category == "") {
              this.$message({
                showClose: true,
                message: "请选择种类",
                type: "warning",
              });
              return false;
            }
          }
        }
      }
      if (num == 3) {
        if (this.isfromchina == 1) {
          var data = {
            domesticnumber: this.order.domesticnumber,
            size: 1,
            page: 1,
          };
          crudDept.selectOrderAllAccuracy(data).then((res) => {
            if (res.content != "") {
              this.$message.error("快递单号重复，请重新输入");
              this.isselectOrderAllAccuracy = true;
              return false;
            } else {
              this.isselectOrderAllAccuracy = false;
              this.step = num;
            }
          });
        } else {
          this.step = num;
        }
      } else {
        this.step = num;
      }
    },
  },
};
</script>

<style scoped>
.displayC {
  display: flex;
  align-items: baseline;
}
.address_model >>> .el-radio__inner {
  width: 26px !important;
  height: 26px !important;
  border-width: 1px !important;
}
.address_model >>> .el-radio__label {
  width: 100% !important;
}
.el-radio {
  width: 100% !important;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.fill_in_list >>> .el-input__inner {
  border: 1px solid transparent !important;
  padding: 0 !important;
}
@media only screen and (min-width: 1200px) {
  .el-col-lg-5 {
    width: 20%;
  }
}
.contents {
  /* transition: left linear .3s; */
}

.upload_img {
  position: relative;
  width: 264px;
  margin: 0;
  /* height: 165px; */
}
.text_remark {
  width: 100%;
  /* display: inline-block; */
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  line-height: 0;
  bottom: -30px;
}
.upload_img .el-upload--picture-card i {
  line-height: 165px;
  font-size: 40px;
}
.el-upload--picture-card {
  width: 264px;
  height: 165px;
  background: #ffffff;
  border: 2px dashed #999999;
  opacity: 1;
  border-radius: 20px;
}
.button_L {
  border-radius: 0px 5px 5px 0px !important;
  background-color: #5178ff !important;
  border-color: #5178ff !important;
}
.input_frg {
  display: flex;
  align-items: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 91px;
  height: 91px;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 5px;
  line-height: 91px;
  text-align: center;
}
.avatar {
  width: 91px;
  height: 91px;
  background: #f5f5f5;
  opacity: 1;
  border-radius: 5px;
  display: block;
}
.transportation_text_op {
  display: flex;
  width: 100%;
  justify-content: center;
}
.color_2 {
  border: 1px solid #ffa401 !important;
  color: #ffa401 !important;
}
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-input__inner {
  background: none !important;
  outline: none !important;
  border: none !important;
  color: #fff !important;
  padding: 0;
}
.margin_top {
  margin-top: 30px;
}
.user-search {
  margin-top: 20px;
}
.title_text {
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #333333;
  margin-left: 10px;
}
.content_box {
  width: 100%;
  height: 93px;
  background: #ffffff;
  padding: 0 58px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.text_color {
  color: #999999 !important;
}
.text_size {
  font-size: 15px !important;
}
.text_color1 {
  font-size: 25px !important;
}
.bgc {
  width: 180px !important;
  border: 1px solid #999 !important;
}
.userRole {
  width: 100%;
}
.line {
  width: 4px;
  height: 24px;
  background-color: #5178ff;
  border-radius: 20px;
}
.step_boxs {
  display: flex;
}
.step_box {
  margin-right: 27px;
}
.center_box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-top: 14px;
  padding: 40px 58px;
  box-sizing: border-box;
}
.step_box_top {
  height: 50px;
  display: flex;
  /* align-items: baseline; */
  align-items: flex-end;
}
.step_number {
  font-size: 38px;

  color: #5178ff;
  margin-right: 10px;
  display: table-cell;
  vertical-align: bottom;
  margin-bottom: -3px;
}
.step_box_text_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #5178ff;
  display: table-cell;
  vertical-align: bottom;
}
.line_box {
  width: 240px;
  height: 0px;
  border: 1px solid #5178ff;
  margin: 5px 0;
}
.step_box_text_b {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #5178ff;
  display: table-cell;
  vertical-align: bottom;
  height: 30px;
}
.step_boxs_details_titile {
  margin-top: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 45px;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.city_box {
  display: flex;
  align-items: center;
}
.city_list_box {
  /* width: 141px; */
  height: 49px;
  padding: 0 30px;
  box-sizing: border-box;
  background: #5178ff;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  margin-right: 90px;
  cursor: pointer;
}
.city_list_boxs {
  height: 49px;
  padding: 0 30px;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  margin-right: 90px;
  font-size: 16px;
  cursor: pointer;
}
.triangle {
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translate(-50%);
  width: 0;
  height: 0;
  border-width: 12px;
  border-style: solid;
  border-color: #5178ff transparent transparent;
  font-size: 0;
  line-height: 0;
}
.flex_box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;
}

.transportation_type_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  border: 1px solid #c5d1ff;
  padding: 40px 53px;
  box-sizing: border-box;
  border-radius: 20px;
  margin-top: 40px;
}
.step_box_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.transportation_type_list {
  width: 100%;
  height: auto;
  /* padding: 0 12px; */
  box-sizing: border-box;
}
.transportation_box_list {
  width: 100%;
  height: auto;
}
.transportation_img_box {
  width: 100%;
  height: 180px;
  background: rgba(0, 0, 0, 0);
  opacity: 1;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.transportation_type_list:hover img {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.transportation_img_box img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: 10px;
}
.transportation_center_box {
  width: 102px;
  height: 102px;
  background: rgba(0, 14, 61, 0.55);
  border-radius: 50%;
  z-index: 1;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.transportation_text {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  color: #fff;
  height: auto;
  /* line-height: 31px; */
  padding: 5px;

  box-sizing: border-box;
  z-index: 22;
  text-align: center;
  width: auto;
  display: inline-block;
}
.transportation_text_titile {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-top: 17px;
  margin-bottom: 5px;
}
.transportation_text_details {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #999999;
  white-space: pre-line;
}
.arrows_box {
  width: 60px;
  height: 28px;
  /* background: #ffffff;
  border: 1px solid #5178ff; */
  opacity: 1;
  /* border-radius: 5px; */
  margin-top: 6px;
}
.fill_in_list_box {
  display: flex;
  flex-wrap: wrap;
}
.fill_in_list {
  width: 27%;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-right: 22px;
}
.fill_in_list_l {
  display: flex;
  align-items: baseline;
}
.fill_in_title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-right: 9px;
}
.fill_in_title_l {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #ff0e0e;
}
input {
  background: none !important;
  outline: none !important;
  border: none !important;
}
.input_select {
  background: none !important;
  outline: none !important;
  border: none !important;
}
input:focus {
  border: none !important;
}
.input_box {
  border: none !important;
  width: 100%;
  margin-top: 9px;
  padding: 0 0 !important;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #2e3136;
}
.step_box_l {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 87px;
}
.last_step {
  width: 150px;
  height: 44px;
  border: 1px solid #999999;
  box-shadow: 0px 3px 6px rgba(0, 102, 255, 0.16);
  opacity: 1;
  border-radius: 25px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  margin: 0 20px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.last_step_l {
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px !important;
  border-radius: 22px;
  margin: 0 20px !important;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
  padding: 0 !important;
  cursor: pointer;
}
.operating_button_box {
  display: flex;
  justify-content: flex-end;
  padding-right: 48px;
  box-sizing: border-box;
  margin-bottom: 15px;
}
.operating_button_l {
  display: flex;
}
.operating_button_l_l {
  width: 117px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #5178ff;
  opacity: 1;
  border-radius: 8px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  margin-left: 12px;
  color: #5178ff;
}
.step_three {
  /* width: 90%; */

  box-sizing: border-box;
}
.table_box {
  width: 100%;
  height: auto;
  display: flex;
}
.table_item {
  width: 100%;
  height: auto;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin-bottom: 20px;
}
.table_item_title_l {
  display: flex;
  justify-content: space-between;
  padding: 25px 48px;
  box-sizing: border-box;
  align-items: center;
}
.case_number {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2e3136;
  margin-right: 30px;
}
.table_item_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 48px;
  box-sizing: border-box;
  border-top: 1px solid #e1e1e1;
}
.table_item_box_l {
  margin-right: 50px;
}
.table_item_box_l_r {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-bottom: 10px;
}
.table_item_input {
  width: 180px;
  height: 40px;
  background: #f1f3f6 !important;
  opacity: 1;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 15px !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.input_select_table {
  background: #f1f3f6 !important;
  padding: 0 !important;
  width: 180px;
  height: 40px;
  background: #f1f3f6;
  opacity: 1;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 15px !important;
}
.input_select_table >>> .el-input__inner {
  background: transparent;
  border: none !important;
}
.step_box_s {
  display: flex;
  justify-content: flex-end;
  margin-top: 58px;
}
.margin_right {
  margin-right: 0 !important;
}
.inout_uio {
  width: 502px;
  height: 40px;
  background: #f1f3f6 !important;
  opacity: 1;
  border-radius: 5px 0 0 5px;
  padding: 0 15px;
  box-sizing: border-box;
}
.address_model {
}
.address_item {
  width: 100%;
  height: auto;
  padding: 32px 44px;
  box-sizing: border-box;
  display: inline-block;

  border: 2px solid #e1e1e1;
  margin-bottom: 20px;
}
.user_info_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user_info {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.user_name {
  margin-right: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.title_text_gh {
  width: 100px;
  font-size: 15px;
  font-family: PingFang SC;
  color: #666666;
}
.title_details {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/* .avatar {
    width: 178px;
    height: 178px;
    display: block;
  } */
</style>

 
 


// WEBPACK FOOTER //
// src/views/goods/Goods.vue